import React from "react";
import { Link } from "react-router-dom";
import { Icons } from "../../../components/ui/icons";
import { DashboardOverview } from "../../../lib/api";
import { formatNumber } from "./format";
import { SectionHeader } from "./section";

const OverviewTiles: React.FC<{ summary?: DashboardOverview["summary"] }> = ({ summary }) => {
  const tiles = [
    { label: "Customers", value: summary?.customers, href: "/customers", icon: Icons.Clients },
    { label: "Sites", value: summary?.sites, href: "/sites", icon: Icons.Location },
    { label: "Warehouses", value: summary?.warehouses, href: "/warehouses", icon: Icons.Building },
    { label: "Quotations", value: summary?.quotations, href: "/quotes", icon: Icons.Quotes },
    { label: "Invoices", value: summary?.invoices, href: "/invoices", icon: Icons.Billing },
    { label: "Movements", value: summary?.movements, href: "/activities", icon: Icons.Movement },
  ];

  return (
    <section>
      <SectionHeader title="Overview" />
      <div className="grid grid-cols-3 gap-2.5">
        {tiles.map((tile) => (
          <Link
            key={tile.label}
            to={tile.href}
            className="rounded-2xl border border-gray-100 bg-white p-3 shadow-[0_1px_2px_rgba(13,14,19,0.04)] transition-transform active:scale-95 [-webkit-tap-highlight-color:transparent]"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
              <tile.icon width={18} height={18} />
            </span>
            <p className="mt-2.5 truncate text-lg font-bold font-jakarta leading-tight text-gray-900">
              {formatNumber(tile.value)}
            </p>
            <p className="truncate text-[11px] font-medium text-gray-500">{tile.label}</p>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default OverviewTiles;
